import { DOMUtils } from '../../../utils/dom'

export class ArticleBlock {
    /**
     * Remove widgets, gallery, all ads except 2nd and 3rd position
     */
    public static removeWidgetsAndAds() {
        const widgetsInContent = document.querySelectorAll(
            '.js-widget-content'
        )
        const galleryBlock = document.querySelector(
            '.gallery-block'
        )
        const articleContentSections = document.querySelectorAll('.article-content__content-group')
        const articleAdSections = document.querySelectorAll('.article-content__ad-group:not(.ad_counter_1):not(.ad_counter_2):not(.ad_counter_3)')

        // Remove all widgets in content
        widgetsInContent.forEach((el) => el.remove())

        // Remove gallery elements and keep gallery block container to make space before excerpt
        if (galleryBlock) {
            galleryBlock.replaceChildren()
        }

        // Remove all content group sections include widgets
        articleContentSections.forEach((el) => el.remove())

        // Remove all ads except 2nd & 3rd position of ads
        articleAdSections.forEach((el) => el.remove())

        // Hide sidebar slots
        DOMUtils.addClass(
            document.querySelector('.article-content__widget-group--sidebar-slot'),
            'hidden'
        )

        // Hide article footer share
        DOMUtils.addClass(
            document.querySelector('.article-content__share-group'),
            'hidden'
        )

        // Hide trending list widget
        DOMUtils.addClass(
            document.querySelector('.list-widget-trending.list'),
            'hidden'
        )
    }
}
